module.exports = __webpack_public_path__ + "59de00c4fd45f877e870d7949bbd0f6c.png";